import React from "react";

import { StyledImageBlock } from "./styled";

const ImageBlock = ({ src = "", styles = {} }) => (
  <StyledImageBlock styles={styles} src={src} />
);

export default ImageBlock;
